const apiBase = process.env.REACT_APP_API_URL;

export async function getUsuarioByIdRoyal(usuario_id) {
  const response = await fetch(`${apiBase}/api/getUsuarioByIdRoyal`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ usuario_id }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Erro ao buscar dados do usuário");
  }

  return data;
}

export async function createEnderecoRoyal(payload) {
  const response = await fetch(`${apiBase}/api/insertEnderecoRoyal`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Erro ao criar endereço");
  }

  return data;
}

export async function deleteEnderecoRoyal(endereco_id) {
  const response = await fetch(`${apiBase}/api/deleteEnderecoByEnderecoIdRoyal`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ endereco_id }),
  });

  const data = await response.json();

  if (!response.ok || data?.Deleted !== "Ok") {
    throw new Error(data.message || data.error || "Erro ao excluir endereço");
  }

  return data;
}

export async function editEnderecoByEnderecoIdRoyal(payload) {
  const response = await fetch(`${apiBase}/api/editEnderecoByEnderecoIdRoyal`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Erro ao editar endereço");
  }

  return data;
}